module.exports = __webpack_public_path__ + "static/media/030-clock.3a110061.svg";